<template>
	<div class="group">
		<div class="header">
			<div class="name" v-text="name"/>
			<div class="count">({{items.length}})</div>
		</div>

		<div class="items">
			<item v-for="item in items" :key="item.id" v-bind="{item}"/>
		</div>
	</div>
</template>

<script>
import item from "./item/index.vue";

export default {
	components: {item},
	props: {
		items: {type: Array, required: true},
		name: {type: String, required: true}
	}
}
</script>

<style lang="scss" scoped>
.group {
	.header {
		margin: 12px 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 500;
	}
}
</style>
